export default "__VITE_ASSET__Tl9qjOSR__"